import { render, staticRenderFns } from "./to-do-draft.vue?vue&type=template&id=19a84458&scoped=true"
import script from "./to-do-draft.vue?vue&type=script&lang=js"
export * from "./to-do-draft.vue?vue&type=script&lang=js"
import style0 from "./to-do-draft.vue?vue&type=style&index=0&id=19a84458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a84458",
  null
  
)

export default component.exports